// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__yvVQA","focus-visible":"tag_focus-visible__LoT8_"};